import { LoggerParamsTransformer } from '@content-platform/web-angular-shared-util-logging';
import { ApplicationApiConstants } from '../application-api-config';

export class ActiveApplicationLoggingTransformer extends LoggerParamsTransformer {
  getParams() {
    return {
      activeApplication: ApplicationApiConstants.activeAppName,
      url: window.location.href,
    };
  }
}
